export default {
	data() {
		return {
			validate: {
				require: [
					v => !!v || 'Field is required',
					v => (!!v && v.trim().length > 0) || 'Cannot be only whitespace',
				],
				requireCustomMessage: (message) => {
					return [
						v => !!v || message,
						v => (!!v && v.trim().length > 0) || 'Cannot be only whitespace',
					];
				},
				email: (v) => {
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					return pattern.test(v) || 'Invalid email';
				},
				max: (v, max) => {
					if (!v) {
						return true;
					}
					return (v && v.length <= max) || `${max} characters max.`;
				},
				lengthMax20: v => (v && v.length <= 20) || '20 characters max.',
				lengthMin8: v => (v && v.length > 7) || '8 characters min.',
				maxNotRequired: (v, max) => (v.length <= max) || `${max} characters max.`,
				urlRules: v => this.validateURLS(v) || 'Invalid URL(s)',
				date: (v) => {
					const pattern = /([1-9][0-9]{3})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/;
					return pattern.test(v) || 'Invalid date';
				},
				number: [
					v => !!v || 'Field is required',
					// eslint-disable-next-line
					v => !isNaN(v) || 'Must be a number',
					v => v > -1 || 'Number must be positive',
				],
			},
		};
	},
	methods: {
		validateDate(date) {
			if (date === null) {
				return true;
			}
			const formatDate = new Date(date);
			const minDate = new Date(1970, 0, 1);
			// const maxDate = new Date();
			// maxDate.setDate(maxDate.getDate() + 15);
			// if (maxDate < formatDate) {
			// 	return 'Date cannot exceed 2 weeks from current.';
			// }
			if (minDate > formatDate) {
				return 'Date cannot be older than 1970';
			}
			return true;
		},
		validateURLS(urlsString) {
			// eslint-disable-next-line
			const pattern = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
			if (urlsString) {
				const urls = urlsString.split('\n');
				for (let i = 0; i < urls.length; i += 1) {
					if (urls[i].length > 0) {
						if (!pattern.test(urls[i])) {
							return false;
						}
					}
				}
			}
			return true;
		},
		validateURL(url) {
			const pattern = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
			if (!pattern.test(url)) {
				return 'Invalid URL';
			}
			return true;
		},
		validateCheckDuplicates(v, existing, message = 'already exists', caseSensitive = false) {
			if (!existing || !v) {
				return true;
			}
			for (let i = 0; i < existing.length; i++) {
				existing[i] = existing[i].trim().replace(/\s+/g, ' ');
				if (!caseSensitive) {
					existing[i] = existing[i].toLowerCase();
				}
			}
			let value = v.trim().replace(/\s+/g, ' ')
			if (!caseSensitive) {
				value = value.toLowerCase();
			}

			if (existing.indexOf(value) > -1) {
				return `${v} ${message}`;
			}
			return true;
		},
		validateSamePass(v, password) {
			if (v === password) {
				return true;
			}
			return 'Passwords do not match';
		},
		validateAuthor(v) {
			if (!v) {
				return true;
			}
			if (v.startsWith('@') || v.startsWith('http')) {
				return 'Author name is incorrectly formatted and will not save';
			}
			return true;
		},
	},
};
